var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Trade Requests")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "progress progress-striped active"
  }, [_c('div', {
    staticClass: "progress-bar",
    staticStyle: {
      "width": "100%"
    }
  })]) : [_c('h2', [_vm._v("Requests for you: ")]), _vm._v(" "), _c('p', [_vm._v("You can accept or decline requests. ")]), _vm._v(" "), (_vm.incomingTrades.length > 0) ? [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.incomingTrades), function(trade) {
    return _c('div', {
      key: trade._id,
      staticClass: "col-md-2 col-sm-3 col-xs-6"
    }, [_c('div', {
      staticClass: "book"
    }, [_c('div', {
      staticClass: "controls"
    }, [_c('i', {
      staticClass: "fa fa-check text-success",
      attrs: {
        "aria-hidden": "true",
        "title": "Approve"
      },
      on: {
        "click": function($event) {
          _vm.updateTrade(trade, true)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-ban text-danger",
      attrs: {
        "aria-hidden": "true",
        "title": "Reject"
      },
      on: {
        "click": function($event) {
          _vm.updateTrade(trade, false)
        }
      }
    })]), _vm._v(" "), _c('img', {
      attrs: {
        "alt": "thumbnail",
        "title": trade.book.title,
        "src": trade.book.thumbnail
      }
    })])])
  }))] : [_vm._m(0)], _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("Your requests: ")]), _vm._v(" "), _c('p', [_vm._v("Your pending requests. ")]), _vm._v(" "), (_vm.outgoingTrades.length > 0) ? [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.outgoingTrades), function(trade) {
    return _c('div', {
      key: trade._id,
      staticClass: "col-md-2 col-sm-3 col-xs-6"
    }, [_c('div', {
      staticClass: "book"
    }, [_c('div', {
      staticClass: "controls"
    }, [_c('i', {
      staticClass: "fa fa-trash text-danger",
      attrs: {
        "aria-hidden": "true",
        "title": "Cancel"
      },
      on: {
        "click": function($event) {
          _vm.cancelTrade(trade)
        }
      }
    })]), _vm._v(" "), _c('img', {
      attrs: {
        "alt": "thumbnail",
        "title": trade.book.title,
        "src": trade.book.thumbnail
      }
    })])])
  }))] : [_vm._m(1)], _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("Completed Trades: ")]), _vm._v(" "), _c('p', [_vm._v("All completed trades will show here.")]), _vm._v(" "), (_vm.completedRequests.length > 0) ? [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.completedRequests), function(trade) {
    return _c('div', {
      key: trade._id,
      staticClass: "col-md-2 col-sm-3 col-xs-6"
    }, [_c('div', {
      staticClass: "book"
    }, [_c('div', {
      staticClass: "controls"
    }, [_c('i', {
      staticClass: "small text-success",
      class: {
        'text-danger': !_vm.getTradeTitle(trade).success
      },
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v(_vm._s(_vm.getTradeTitle(trade).message))])]), _vm._v(" "), _c('img', {
      attrs: {
        "alt": "thumbnail",
        "title": trade.book.title,
        "src": trade.book.thumbnail
      }
    })]), _vm._v(" "), (trade.owner._id == _vm.getUser._id) ? _c('p', [_c('span', [_c('strong', [_vm._v("Contact Number: ")]), _vm._v(_vm._s(trade.trader.contact_number))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Name: ")]), _vm._v(_vm._s(trade.trader.first_name + ' ' + trade.trader.last_name))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Adress: ")]), _vm._v(_vm._s(trade.trader.city + ', ' + trade.trader.state))]), _c('br')]) : _c('p', [_c('span', [_c('strong', [_vm._v("Contact Number: ")]), _vm._v(_vm._s(trade.owner.contact_number))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Name: ")]), _vm._v(_vm._s(trade.owner.first_name + ' ' + trade.owner.last_name))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Adress: ")]), _vm._v(_vm._s(trade.owner.city) + " " + _vm._s(trade.owner.state))]), _c('br')])])
  }))] : [_vm._m(2)]]], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_c('p', [_vm._v("No incoming book requests.")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_c('p', [_vm._v("You have no pending requests.")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_c('p', [_vm._v("You have no requests completed. ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-edbce252","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/trades.vue
// module id = 101
// module chunks = 0